export const logoReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_LOGO':
            return {
                ...state,
                name: action.name
            };
        case 'UPDATE_LOCAL_URL':
            return {
                ...state,
                localUrl: action.url
            };
        case 'UPDATE_LOCAL_FILE':
            return {
                ...state,
                localFile: action.localFile
            };
        case 'UPDATE_LOCAL_LABEL':
            return {
                ...state,
                localLabel: action.localLabel
            };
        case 'UPDATE_WEB_URL':
            return {
                ...state,
                webUrl: action.url
            };
        case 'UPDATE_DROPDOWN':
            return {
                ...state,
                dropdown: action.dropdown
            };
        case 'UPDATE_LOCAL_WIDTH':
            return {
                ...state,
                localWidth: action.width
            };
        case 'UPDATE_WEB_WIDTH':
            return {
                ...state,
                webWidth: action.width
            };
        case 'UPDATE_WATERMARK':
            return {
                ...state,
                watermarkHidden: action.watermarkHidden
            };
        default:
            return state;
    }
}
